import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from 'constants/redux/conversations';

const initialState = {
  isFetching: false,
  data: [],
  error: null,
  limit: 20,
  filter: [],
  offset: 0,
  totalRecords: 20, // just non zero initial value which will be over written.
};

const setFetchConversationsRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
  });

const setFetchConversationsSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $push: action.payload.results },
    error: { $set: {} },
    totalRecords: { $set: action.payload.totalRecords },
    offset: { $set: state.offset + state.limit },
  });

const setFetchConversationsFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: [] },
    offset: { $set: 0 },
    error: { $set: action.payload.error },
  });

const clearConversations = (state) =>
  update(state, {
    isFetching: { $set: initialState.isFetching },
    data: { $set: initialState.data },
    error: { $set: initialState.error },
    limit: { $set: initialState.limit },
    filter: { $set: initialState.filter },
    offset: { $set: initialState.offset },
    totalRecords: { $set: initialState.totalRecords },
  });

const setConversationsFilter = (state, action) =>
  update(state, {
    data: { $set: [] },
    filter: { $set: action.payload.filter },
    limit: { $set: initialState.limit },
    offset: { $set: initialState.offset },
    totalRecords: { $set: initialState.totalRecords },
  });

export default handleActions(
  {
    [constants.FETCH_CONVERSATIONS_REQUEST]: setFetchConversationsRequest,
    [constants.FETCH_CONVERSATIONS_SUCCESS]: setFetchConversationsSuccess,
    [constants.FETCH_CONVERSATIONS_FAILURE]: setFetchConversationsFailure,

    [constants.CLEAR_CONVERSATIONS]: clearConversations,
    [constants.SET_CONVERSATIONS_FILTER]: setConversationsFilter,
  },
  initialState,
);
